import React from 'react';
import {Text, View, Image, StyleSheet } from '@react-pdf/renderer';

// Images 
import INR from "../../../../assets/INR.png";
import percent from "../../../../assets/percent.png";

const borderColor = '#404040'
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        borderBottomColor: '#404040',
        borderBottomWidth: 1,
        alignItems: 'center',
        height: 24,
        fontSize: 12,
        fontStyle: 'bold',
    },
    description: {
        width: '80%',
        textAlign: 'right',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        paddingRight: 8,
        paddingTop: 5,
        // flexDirection: 'row',
        borderBottomColor: '#bff0fd',
        backgroundColor: '#c00000',
        borderBottomWidth: 1,
        // alignItems: 'center',
        height: 24,
        // textAlign: 'center',
        fontSize: 10,
        fontStyle: 'bold',
        // flexGrow: 1,
        color: '#ffffff'
    },
    total: {
        width: '20%',
        textAlign: 'right',
        paddingRight: 8,
    },
    INR: {
        height: "8px",
        marginLeft: 8,
    },
    percent: {
        height: "7px",
        marginLeft: 6,
    }
  });


const InvoiceTableFooter = ({items}) => {
    const total = items.map(item => item.total)
        .reduce((accumulator, currentValue) => accumulator + currentValue , 0);
    return(    
        <View>
            {/* <View style={styles.row}>
                <Text style={styles.description}>TOTAL</Text>
                <Image style={styles.INR} src={INR} />
                <Text style={styles.total}>{ Number.parseFloat(total).toFixed(2)}</Text>
            </View>
            <View style={styles.row}>
                <Text style={styles.description}>GST Rate</Text>
                <Image style={styles.percent} src={percent} />
                <Text style={styles.total}>18.00</Text>
            </View>
            <View style={styles.row}>
                <Text style={styles.description}>GST</Text>
                <Text style={styles.description}>GST RATE 18.00%</Text>
                <Image style={styles.INR} src={INR} />
                <Text style={styles.total}>{ Number.parseFloat((total/100)*18).toFixed(2)}</Text>
            </View> */}
            <View style={styles.row}>
                {/* <Text style={styles.description}>AMOUNT PAYABLE</Text> */}
                <Text style={styles.description}>AMOUNT PAID</Text>
                <Image style={styles.INR} src={INR} />
                {/* <Text style={styles.total}>{ Number.parseFloat(total+((total/100)*18)).toFixed(2)}</Text> */}
                <Text style={styles.total}>{ Number.parseFloat(total).toFixed(2)}</Text>
            </View>
        </View>
        
    )
};
  
  export default InvoiceTableFooter